/**
 * Created by dziamid on 11.5.17.
 */
import { ADD_ENTITIES, CLEAR_ENTITIES, CLEAR_ENTITIES_BY_ID, CLEAR_SINGLE_ENTITY, UPDATE_ENTITIES } from './constrants';

import { IModelName } from './types';

export function addEntities(entities: any, replace?: boolean) {
  return {
    type: ADD_ENTITIES,
    entities,
    replace,
  };
}

export function clearEntities(names?: IModelName[]) {
  return {
    type: CLEAR_ENTITIES,
    names,
  };
}

export function clearEntitiesById(name: string, ids: string[]) {
  return {
    type: CLEAR_ENTITIES_BY_ID,
    name,
    ids,
  };
}

export function clearSingleEntity(name: string, id: string) {
  return {
    type: CLEAR_SINGLE_ENTITY,
    name,
    id,
  };
}

export function updateEntities(name: string, entities: any[]) {
  return {
    type: UPDATE_ENTITIES,
    name,
    entities,
  };
}
